/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const locationMemberSchema = z.object({
  createdAt: z.iso.datetime(),
  createdBy: z.string(),
  id: z.int(),
  locationId: z.int(),
  organizationId: z.string(),
  overridden: z.boolean(),
  resourceId: z.int(),
  updatedAt: z.iso.datetime(),
  updatedBy: z.string(),
});
